import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import ArrayList from './ArrayList';
import SortedMap from './SortedMap';
import HashSet from './HashSet';
var BLACK = 0;
var RED = 1;
function colorOf(p) {
  return p == null ? BLACK : p.color;
}
function parentOf(p) {
  return p == null ? null : p.parent;
}
function setColor(p, c) {
  if (p !== null) p.color = c;
}
function leftOf(p) {
  return p == null ? null : p.left;
}
function rightOf(p) {
  return p == null ? null : p.right;
}

/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/TreeMap.html
 */
var TreeMap = /*#__PURE__*/function (_SortedMap) {
  _inherits(TreeMap, _SortedMap);
  function TreeMap() {
    var _this;
    _classCallCheck(this, TreeMap);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TreeMap).call(this));
    _this.root_ = null;
    _this.size_ = 0;
    return _this;
  }
  _createClass(TreeMap, [{
    key: "get",
    value: function get(key) {
      var p = this.root_;
      while (p !== null) {
        var cmp = key.compareTo(p.key);
        if (cmp < 0) p = p.left;else if (cmp > 0) p = p.right;else return p.value;
      }
      return null;
    }
  }, {
    key: "put",
    value: function put(key, value) {
      if (this.root_ === null) {
        this.root_ = {
          key: key,
          value: value,
          left: null,
          right: null,
          parent: null,
          color: BLACK,
          getValue: function getValue() {
            return this.value;
          },
          getKey: function getKey() {
            return this.key;
          }
        };
        this.size_ = 1;
        return null;
      }
      var t = this.root_;
      var parent;
      var cmp;
      do {
        parent = t;
        cmp = key.compareTo(t.key);
        if (cmp < 0) {
          t = t.left;
        } else if (cmp > 0) {
          t = t.right;
        } else {
          var oldValue = t.value;
          t.value = value;
          return oldValue;
        }
      } while (t !== null);
      var e = {
        key: key,
        left: null,
        right: null,
        value: value,
        parent: parent,
        color: BLACK,
        getValue: function getValue() {
          return this.value;
        },
        getKey: function getKey() {
          return this.key;
        }
      };
      if (cmp < 0) parent.left = e;else parent.right = e;
      this.fixAfterInsertion(e);
      this.size_++;
      return null;
    }
    /**
     * @param {Object} x
     */
  }, {
    key: "fixAfterInsertion",
    value: function fixAfterInsertion(x) {
      var y;
      x.color = RED;
      while (x != null && x !== this.root_ && x.parent.color === RED) if (parentOf(x) === leftOf(parentOf(parentOf(x)))) {
        y = rightOf(parentOf(parentOf(x)));
        if (colorOf(y) === RED) {
          setColor(parentOf(x), BLACK);
          setColor(y, BLACK);
          setColor(parentOf(parentOf(x)), RED);
          x = parentOf(parentOf(x));
        } else {
          if (x === rightOf(parentOf(x))) {
            x = parentOf(x);
            this.rotateLeft(x);
          }
          setColor(parentOf(x), BLACK);
          setColor(parentOf(parentOf(x)), RED);
          this.rotateRight(parentOf(parentOf(x)));
        }
      } else {
        y = leftOf(parentOf(parentOf(x)));
        if (colorOf(y) === RED) {
          setColor(parentOf(x), BLACK);
          setColor(y, BLACK);
          setColor(parentOf(parentOf(x)), RED);
          x = parentOf(parentOf(x));
        } else {
          if (x === leftOf(parentOf(x))) {
            x = parentOf(x);
            this.rotateRight(x);
          }
          setColor(parentOf(x), BLACK);
          setColor(parentOf(parentOf(x)), RED);
          this.rotateLeft(parentOf(parentOf(x)));
        }
      }
      this.root_.color = BLACK;
    }
  }, {
    key: "values",
    value: function values() {
      var arrayList = new ArrayList();
      var p = this.getFirstEntry();
      if (p !== null) {
        arrayList.add(p.value);
        while ((p = TreeMap.successor(p)) !== null) arrayList.add(p.value);
      }
      return arrayList;
    }
  }, {
    key: "entrySet",
    value: function entrySet() {
      var hashSet = new HashSet();
      var p = this.getFirstEntry();
      if (p !== null) {
        hashSet.add(p);
        while ((p = TreeMap.successor(p)) !== null) hashSet.add(p);
      }
      return hashSet;
    }
    /**
     * @param {Object} p
     */
  }, {
    key: "rotateLeft",
    value: function rotateLeft(p) {
      if (p != null) {
        var r = p.right;
        p.right = r.left;
        if (r.left != null) r.left.parent = p;
        r.parent = p.parent;
        if (p.parent == null) this.root_ = r;else if (p.parent.left === p) p.parent.left = r;else p.parent.right = r;
        r.left = p;
        p.parent = r;
      }
    }
    /**
     * @param {Object} p
     */
  }, {
    key: "rotateRight",
    value: function rotateRight(p) {
      if (p != null) {
        var l = p.left;
        p.left = l.right;
        if (l.right != null) l.right.parent = p;
        l.parent = p.parent;
        if (p.parent == null) this.root_ = l;else if (p.parent.right === p) p.parent.right = l;else p.parent.left = l;
        l.right = p;
        p.parent = l;
      }
    }
    /**
     * @return {Object}
     */
  }, {
    key: "getFirstEntry",
    value: function getFirstEntry() {
      var p = this.root_;
      if (p != null) while (p.left != null) p = p.left;
      return p;
    }
    /**
     * @param {Object} t
     * @return {Object}
     * @private
     */
  }, {
    key: "size",
    value: function size() {
      return this.size_;
    }
  }, {
    key: "containsKey",
    value: function containsKey(key) {
      var p = this.root_;
      while (p !== null) {
        var cmp = key.compareTo(p.key);
        if (cmp < 0) p = p.left;else if (cmp > 0) p = p.right;else return true;
      }
      return false;
    }
  }], [{
    key: "successor",
    value: function successor(t) {
      var p;
      if (t === null) {
        return null;
      } else if (t.right !== null) {
        p = t.right;
        while (p.left !== null) p = p.left;
        return p;
      } else {
        p = t.parent;
        var ch = t;
        while (p !== null && ch === p.right) {
          ch = p;
          p = p.parent;
        }
        return p;
      }
    }
  }]);
  return TreeMap;
}(SortedMap);
export { TreeMap as default };